import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnalytics = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15 20v-8.75h5V20h-5Zm-7.5 0V0h5v20h-5ZM0 20V6.25h5V20H0Z" })
});
export { SvgAnalytics as ReactComponent };
